import React from 'react';
import Loadable from 'react-loadable';

import Loader from '../../utils/Loader';
import AuthenticatedLayout from '../../components/Layouts/Authenticated';
import { ADVANCE_PAYMENT_GUARANTEE, PERFORMANCE_GUARANTEE } from '../../components/contract-guarantees/config';

const Queue = Loadable({
    loader: () => import('./queue' /* webpackChunkName: "Bank-contract-guarantees" */),
    loading() {
        return <Loader />;
    },
});

const Review = Loadable({
    loader: () => import('./review' /* webpackChunkName: "Bank-contract-guarantees" */),
    loading() {
        return <Loader />;
    },
});

export const BankPerformanceGuaranteesComponent = () => (
    <AuthenticatedLayout>
        <Queue config={PERFORMANCE_GUARANTEE} />
    </AuthenticatedLayout>
);

export const ReviewPerformanceGuaranteeComponent = () => (
    <AuthenticatedLayout>
        <Review config={PERFORMANCE_GUARANTEE} />
    </AuthenticatedLayout>
);

export const BankAdvancePaymentGuaranteesComponent = () => (
    <AuthenticatedLayout>
        <Queue config={ADVANCE_PAYMENT_GUARANTEE} />
    </AuthenticatedLayout>
);

export const ReviewAdvancePaymentGuaranteeComponent = () => (
    <AuthenticatedLayout>
        <Review config={ADVANCE_PAYMENT_GUARANTEE} />
    </AuthenticatedLayout>
);
